/**
 * 角色分配相关工具函数
 */
import { AdminRecord } from "../config/panelTableConfig";
import { Role } from "../services/roleService";

/**
 * 从管理员记录中提取角色ID列表
 * @param admin 管理员记录
 * @returns 角色ID列表
 */
export const extractRoleIdsFromAdmin = (admin: AdminRecord | null): string[] => {
  if (!admin?.roles) return [];

  return admin.roles.map((role: any) => (typeof role === "string" ? role : role.id));
};

/**
 * 验证角色数据
 * @param roles 角色列表
 * @returns 是否有效
 */
export const validateRoleData = (roles: Role[]): boolean => {
  return Array.isArray(roles) && roles.length >= 0;
};

/**
 * 格式化角色数据用于显示
 * @param role 角色对象
 * @returns 格式化的角色信息
 */
export const formatRoleForDisplay = (role: Role) => {
  return {
    id: role.id,
    name: role.role_name || "未知角色",
    code: role.role_code || "",
    description: role.description || "无描述",
  };
};

/**
 * 检查角色是否已被选中
 * @param roleId 角色ID
 * @param selectedRoles 已选中的角色ID列表
 * @returns 是否已被选中
 */
export const isRoleSelected = (roleId: string, selectedRoles: string[]): boolean => {
  return selectedRoles.includes(roleId);
};

/**
 * 生成模态框标题
 * @param adminAccount 管理员账号
 * @returns 模态框标题
 */
export const generateModalTitle = (adminAccount: string): string => {
  return `为管理员 "${adminAccount}" 分配角色`;
};

/**
 * 处理角色选择变化
 * @param selectedRowKeys 选中的行键（支持 React.Key[] 类型）
 * @param selectedRows 选中的行数据
 * @param onSelectionChange 选择变化回调
 */
export const handleRoleSelectionChange = (
  selectedRowKeys: React.Key[],
  selectedRows: any[],
  onSelectionChange?: (selectedRowKeys: React.Key[], selectedRows: any[]) => void
) => {
  // 转换为字符串数组以兼容旧代码
  const stringKeys = selectedRowKeys.map(key => String(key));
  onSelectionChange?.(stringKeys as any, selectedRows);
};
